const setDevice = () => {
  switch (true) {
    case window.innerWidth <= 768:
      return "mobile";
    case window.innerWidth <= 1280:
      return "tablet";
    default:
      return "computer";
  }
};

const makeUniconsentClickable = () => {
  const uniconsent = document.querySelector("#uniccmp");

  if (uniconsent) {
    uniconsent.classList.add("ug-exit-preview-helper-container");
  }
};

const useUserGuiding = (user) => {
  const userId = user?.id || crypto.randomUUID();
  const device = setDevice();
  makeUniconsentClickable();

  if (window.userGuiding) {
    window.userGuiding.identify(userId, {
      id: userId,
      email: user?.email,
      name: user?.name,
      device_custom: device,
    });
  } else {
    console.log("window.userGuiding not found, skipping user guiding setup");
    setTimeout(() => {
      useUserGuiding(user);
    }, 1000);
  }
};

export default useUserGuiding;
